import type { TooltipWithButtonProps } from '@which/seatbelt'

import type { AnnualRunningCost } from '../../../generated/frontend'

export const addHandlerToRunningCostTooltip = (
  annualRunningCost: FormattedRunningCost | undefined,
  openHandler: TooltipWithButtonProps['openHandler'],
  closeHandler?: TooltipWithButtonProps['closeHandler']
) => {
  if (annualRunningCost?.tooltip) {
    const transformedRunningCost = {
      ...annualRunningCost,
      tooltip: {
        ...annualRunningCost.tooltip,
        openHandler,
        closeHandler,
      },
    }

    return transformedRunningCost
  }

  return annualRunningCost
}

export type FormattedRunningCost = {
  priceLabel: string | JSX.Element
  ranking?: JSX.Element
  tooltip: FormattedTooltip
}

type FormattedTooltip = AnnualRunningCost['tooltip'] & {
  openHandler?: TooltipWithButtonProps['openHandler']
}
